<main>
  <div *ngIf="!(afAuth.authState | async)">
    <img width="200px" src="/assets/signin.svg">
    <h1>Login</h1>

    <button mat-raised-button appGoogleSignin>
      <img src="/assets/google-logo.svg" /> Login with Google
    </button>

    <h4>OR</h4>

    <app-email-login></app-email-login>
  </div>

  <div *ngIf="afAuth.authState | async as user" class="logout">
    <img class="avatar" [src]="user.photoURL || 'assets/avatar.svg'">
    <p>
      Logged in as <strong>{{ user.email }}</strong>
    </p>

    <button mat-stroked-button (click)="afAuth.auth.signOut()">Logout</button>
  
    <mat-card>
      <h2>Membership</h2>
      <p>become a member</p>
    </mat-card>

    <mat-card *ngIf="">
      
      <button mat-raised-button routerLink="/customers">🤝 MEMBERS</button>

    </mat-card>

  </div> 
</main>